import React from "react";
import { Box } from "@mui/system";

export default Box;
